<template>
  <transition name="modal">
    <div class="modal-mask" v-bind:id="id">
      <div class="modal-wrapper">
        <div class="modal-dialog modal-container">
          <div class="modal-content">
            <div class="modal-header" v-if="!hideHeader">
              <slot name="modal-header">
                <h5 class="modal-title">
                  {{ title }}
                </h5>
              </slot>
            </div>

            <div class="modal-body">
              <slot></slot>
            </div>

            <div class="modal-footer" v-if="!hideFooter">
              <slot name="modal-footer">
                <button
                  v-if="!isHideCloseButton"
                  type="button"
                  class="btn"
                  :class="buttonClassName"
                  @click="$emit('cancel')"
                >
                  {{ closeTitle }}
                </button>
                <button
                  v-if="!okBusy"
                  type="button"
                  class="btn"
                  :class="buttonClassName"
                  @click="$emit('ok')"
                  :disabled="okDisabled"
                >
                  <template v-if="!okBusy">
                    {{ okTitle }}
                  </template>
                </button>
                <LoadingBounce class="w-90" v-else></LoadingBounce>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'custom-modal',

  props: {
    id: String,
    title: String,
    okTitle: {
      type: String,
      default: '확인',
    },
    closeTitle: {
      type: String,
      default: '취소',
    },
    okDisabled: {
      type: Boolean,
      default: false,
    },
    okBusy: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    isHideCloseButton: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    buttonClassName: {
      type: String,
      default: 'btn-primary',
    },
  },
};
</script>
